if (!customElements.get("product-medias")) {
	customElements.define(
		"product-medias",
		class ProductMedias extends HTMLElement {
			constructor() {
				super();

				this.medias = this.querySelectorAll(".product__media");
				this.medias.forEach((media) => {
					const mediaParent = media.closest(".media");
					const zoomBtn = document.getElementById(
						mediaParent?.dataset.zoomBtnId
					);

					media.addEventListener("click", (event) => {
						if (!this.isMobile()) {
							this.toggleZoomClass(media);
							this.handleMouseMove(media, event);
						}
					});

					zoomBtn.addEventListener("click", (event) => {
						event.stopPropagation();
						this.toggleZoomClass(media);
						media.style.transformOrigin = "50% 50%";
					});

					media.addEventListener("mousemove", (event) => {
						this.handleMouseMove(media, event);
					});
					media.addEventListener("mouseleave", () => {
						media.classList.remove("zoomed");
					});

					media.addEventListener(
						"touchmove",
						(event) => {
							this.handleTouchMove(media, event);
						},
						{ passive: false }
					);
					media.addEventListener("touchcancel", () => {
						media.classList.remove("zoomed");
					});
				});
			}

			isMobile() {
				return window.innerWidth <= 750;
			}

			toggleZoomClass(media) {
				media.classList.toggle("zoomed");
			}

			handleMouseMove(media, event) {
				if (!media.classList.contains("zoomed")) return;
				const rect = media.getBoundingClientRect();
				const x = event.clientX - rect.left;
				const y = event.clientY - rect.top;
				const xPercent = (x / rect.width) * 100;
				const yPercent = (y / rect.height) * 100;
				media.style.transformOrigin = `${xPercent}% ${yPercent}%`;
			}

			handleTouchMove(media, event) {
				if (!media.classList.contains("zoomed")) return;
				event.preventDefault();
				const touch = event.touches[0];
				if (!touch) return;
				const rect = media.getBoundingClientRect();
				const x = touch.clientX - rect.left;
				const y = touch.clientY - rect.top;
				const xPercent = (x / rect.width) * 100;
				const yPercent = (y / rect.height) * 100;
				media.style.transformOrigin = `${xPercent}% ${yPercent}%`;
			}
		}
	);
}
